export const domains = {
  prod: '.gambacrm.com',
  stage: '.applebrie.io',
  dev: '.applebrie.co',
}
